import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../../services/config';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { ActiveCompartmentsModel, UliEndpoint } from '../../uli';

@Injectable({ providedIn: 'root' })
export class AllocationViewActionsCompartmentsService {
  constructor(private http: WrapperHttpService) {}

  getCompartments(hubId: number): Observable<ActiveCompartmentsModel[]> {
    return this.http
      .withLoading()
      .get(`${API_URL}${UliEndpoint.Hubs}/${hubId}${UliEndpoint.Compartments}${UliEndpoint.Active}`);
  }
}
